import * as React from 'react'
import {useEffect, useLayoutEffect, useState} from 'react'
import {DataObjectId, Hub} from 'yougile-model'
import {useSyncEvent} from '@containers/hooks'
import {ChatSettings} from '@extensions/chat-settings'
import {VotingPopup} from '../right-panel/voting-popup'
import {ChatInput, ChatInputContext, ChatInputStore} from './chat-input'
import {ChatLabelsContext, ChatLabelsStore, ChatMessages} from './chat-messages'
import {ChatContext, ChatStore} from './chat-store'

type Props = {
  hub: Hub | undefined
  noTabs: boolean
  headerHeight: number
  autofocus: boolean
}

let initApp = true

setTimeout(() => {
  initApp = false
}, 2000)

export const Chat = ({hub, noTabs, headerHeight, autofocus}: Props) => {
  const [chatStore] = useState(() => new ChatStore(hub, noTabs))
  const [chatLabelsStore] = useState(() => new ChatLabelsStore(chatStore))
  const [chatInputStore] = useState(
    () => new ChatInputStore(chatStore, autofocus)
  )

  useEffect(() => {
    return () => {
      chatInputStore.dispose()
    }
  }, [])

  useLayoutEffect(() => {
    chatInputStore.setAutoFocus(autofocus)
  }, [autofocus])

  useLayoutEffect(() => {
    chatStore.syncOnNew(hub, noTabs)
    chatInputStore.syncOnNew()
    chatLabelsStore.syncOnUpdate()
  }, [hub?.id])

  useSyncEvent(
    'custom',
    {filter: hub?.id, companyId: hub?.companyId as unknown as DataObjectId},
    () => {
      chatStore.syncOnUpdate(initApp)
      chatLabelsStore.syncOnUpdate()
      chatInputStore.syncOnUpdate()
    },
    [hub?.id]
  )

  const settingsHub = ChatSettings.getSettingsHub()
  useSyncEvent(
    'custom',
    {
      companyId: settingsHub.companyId,
      filter: settingsHub.id
    },
    () => {
      chatStore.syncOnUpdate(initApp)
      chatLabelsStore.syncOnUpdate()
      chatInputStore.syncOnUpdate()
    },
    [settingsHub.id]
  )

  return (
    <>
      <div className="_preload">
        <img src="/img/chat/chat-background-new2.png" alt="" />
      </div>

      <ChatContext.Provider value={chatStore}>
        <ChatLabelsContext.Provider value={chatLabelsStore}>
          <ChatMessages />
        </ChatLabelsContext.Provider>
        <ChatInputContext.Provider value={chatInputStore}>
          <ChatInput headerHeight={headerHeight} />
          <VotingPopup />
        </ChatInputContext.Provider>
      </ChatContext.Provider>
    </>
  )
}
